import React, { useState, useEffect } from 'react';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { Select as BENE_SELECT } from 'Components/Api/VastWebDMTAPI';
import { DeleteBeneficiary as BENE_DELETE } from 'Components/Api/VastWebDMTAPI';
import { LOGOUT } from 'ConstComponents';
import { useHistory } from 'react-router';
import { DMTTransactionConfirmation } from 'Components/Alert/DMTTransactionConfirmation';
import { MoneyTransfer as DMT_TRANSFER } from 'Components/Api/VastWebDMTAPI';
import * as Yup from 'yup';
import {
    MONEY_TRANSFER_CODE,
    MONEY_TRANSFER_OPERATOR_TRANSFER_CODE,
    MONEY_TRANSFER_OPERATOR_VERIFY_CODE,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
var mobile = '';
export default function BeneficiaryList({
    senderNo,
    ActiveDMTName,
    senderName,
    setIsError,
    setSeverity,
    setLoading,
    setResponseMessage,
    formRef
}) {
    const classes = commonStyle();
    const history = useHistory();
    const [beneList, setBeneList] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [serviceCode, setserviceCode] = useState(MONEY_TRANSFER_CODE);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    mobile = senderNo;
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});

    useEffect(() => {
        selectData();
        createColumns();
    }, [mobile]);

    const selectData = async () => {
        setBeneList([]);
        setLoading(true);
        setIsError(false);

        var beneReqObj = JSON.stringify({
            Mobile: senderNo,
            DMTName: ActiveDMTName
        });

        var response = await BENE_SELECT(beneReqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }
        var data = JSON.parse(response.data);
        setBeneList(data.benelist);
    };

    const Transfer = async (request) => {
        let jsonObj = {
            Mobile: mobile,
            Name: request.BeniName,
            SenderName: senderName,
            BankName: request.BankName,
            AccountNo: request.AccountNumber,
            IFSC: request.IFSC,
            BeneficiaryID: request.BeneficiaryID,
            SenderID: mobile,
            Amount: request.Amount,
            PaymentType: request.PaymentType,
            RechargePin: request.RechargePin,
            Remark: request.Remark,
            DMTName: ActiveDMTName
        };
        setIsError(false);
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(apirequest);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setResponseMessage(dataError.Message);
            setSeverity('error');
            setIsError(true);
            selectData();
            return;
        }

        var data = JSON.parse(response.data);

        setResponseAlert(data);
        setIsResponseAlertOpen(true);
        selectData();
    };

    const Verify = async (values) => {
        var jsonObj = {
            BeneficiaryID: values.BeneficiaryID,
            Name: values.BeniName,
            SenderName: senderName,
            BankName: values.BankName,
            AccountNo: values.AccountNumber,
            IFSC: values.IFSC,
            SenderID: mobile,
            Mobile: mobile,
            PaymentType: 'IMPS',
            Through: 'WEB',
            IsVerify: true,
            Amount: 1,
            RechargePin: values.RechargePin,
            DMTName: ActiveDMTName
        };

        setLoading(true);
        setIsError(false);

        var request = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(request);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setResponseMessage(dataError.Message);
            setSeverity('error');
            setIsError(true);
            selectData();
            return;
        }

        setSeverity('success');
        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setIsError(true);
        if (formRef.current) formRef.current.handleSubmit();

        if (data.Status === 'FAILURE') {
            setSeverity('error');
            selectData();
            return;
        }
    };

    const Delete = async (values) => {
        let SenderID = '';
        if (isPin !== 'true') {
            SenderID = values[9];
        } else {
            SenderID = values[10];
        }

        var jsonObj = {
            BeneficiaryID: values[0],
            SenderID: senderNo,
            MobileNumber: mobile,
            DMTName: ActiveDMTName
        };

        setLoading(true);
        setIsError(false);

        var request = JSON.stringify(jsonObj);

        var response = await BENE_DELETE(request);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();
        setIsError(true);
        setResponseMessage(response.data);
        if (!response.status) {
            setSeverity('error');
            selectData();
            return;
        }
        setSeverity('success');
        selectData();
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const MTTransferValidation = Yup.object({
        BeniName: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        BeneficiaryID: Yup.string().required(PLEASE_PROVIDE_VALID + 'bene'),
        BankName: Yup.string().required(PLEASE_PROVIDE_VALID + 'bank'),

        AccountNumber: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC'),

        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(0, PLEASE_PROVIDE_VALID + 'amount'),
        RechargePin: Yup.string().when(['IsPin'], {
            is: (isPin) => isPin === 'true',

            then: Yup.string().required('Please enter pin')
        })
    });

    const MTTransferConfirmation = async (values) => {
        setConfirmAlertRequest({});
        let SenderID = values[10];
        let RechargePin = values[6];
        if (isPin !== 'true') {
            SenderID = values[9];
            RechargePin = '';
        }
        if (RechargePin === undefined) {
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[1],
            BankName: values[2],
            AccountNumber: values[3],
            IFSC: values[4],
            Amount: values[5],
            RechargePin: RechargePin,
            SenderID: SenderID,
            OperatorID: MONEY_TRANSFER_OPERATOR_TRANSFER_CODE,
            ServiceID: MONEY_TRANSFER_CODE,
            IsPin: isPin
        };

        setIsError(false);

        var errorValidation = false;

        await MTTransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);

            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const VerifyConfirmation = async (values) => {
        setConfirmAlertRequest({});
        let SenderID = values[10];
        let RechargePin = values[6];
        if (isPin !== 'true') {
            SenderID = values[9];
            RechargePin = '';
        }

        if (RechargePin === undefined) {
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[1],
            BankName: values[2],
            AccountNumber: values[3],
            IFSC: values[4],
            Amount: 1,
            RechargePin: RechargePin,
            SenderID: SenderID,
            OperatorID: MONEY_TRANSFER_OPERATOR_VERIFY_CODE,
            ServiceID: MONEY_TRANSFER_CODE,
            IsPin: isPin
        };

        var errorValidation = false;

        await MTTransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'id',
            srno: true
        });

        columns.push({
            label: 'Name',
            name: 'name'
        });
        columns.push({
            label: 'Bank',
            name: 'bank'
        });
        columns.push({
            label: 'AccountNo',
            name: 'account'
        });

        columns.push({
            label: 'IFSC',
            name: 'ifsc'
        });

        columns.push({
            label: 'Amount',
            name: 'amount',
            editableWithNumberOnly: true,
            length: 6
        });

        if (isPin === 'true') {
            columns.push({
                label: 'Pin',
                name: 'RechargePin',
                editableWithPinOnly: true,
                length: 4
            });
        }

        columns.push({
            label: 'Verified',
            name: 'verified',
            buttonTitle: 'Verify',
            buttonOrLabel: true,
            callback: (values) => {
                VerifyConfirmation(values);
            }
        });

        columns.push({
            label: 'Transfer',
            name: 'id',
            transfer: true,
            buttonTitle: 'Transfer',
            callback: (value) => {
                MTTransferConfirmation(value);
            }
        });

        columns.push({
            label: 'Delete',
            name: 'id',
            icon: 'DeleteIcon',
            iconButtonWithRow: true,
            callback: (value) => {
                Delete(value);
            }
        });

        setMainColumns(columns);
    };

    const sendCallback = (data) => {
        setIsResponseAlertOpen(false);

        setSeverity('success');
        if (data.Status === 'FAILURE') {
            setSeverity('error');
        }
        setResponseMessage(data.Message);
        setIsError(true);
    };

    if (senderNo === undefined || senderNo === null || senderNo.length <= 5) {
        return null;
    }

    return (
        <>
            <h2 className={classes.PaperHead_h2}>Beneficiaries</h2>

            <ReactTable data={beneList} columns={mainColumns} />

            {isAlertOpen ? (
                <DMTTransactionConfirmation
                    ActiveDMTName={ActiveDMTName}
                    isOpen={isAlertOpen}
                    title="Domestic Money Transfer"
                    message="Are you sure to do this transaction?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        if (
                            parseInt(request.ServiceID) ===
                                MONEY_TRANSFER_CODE &&
                            parseInt(request.OperatorID) ===
                                MONEY_TRANSFER_OPERATOR_TRANSFER_CODE
                        ) {
                            Transfer(request);
                        }

                        if (
                            parseInt(request.ServiceID) ===
                                MONEY_TRANSFER_CODE &&
                            parseInt(request.OperatorID) ===
                                MONEY_TRANSFER_OPERATOR_VERIFY_CODE
                        ) {
                            Verify(request);
                        }
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                        selectData();
                    }}
                />
            ) : null}

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={ResponseAlert.Status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        sendCallback(ResponseAlert);
                    }}
                />
            ) : null}
        </>
    );
}
